module.exports = __webpack_public_path__ + "img/UTBEAR-8.ed20e8df.jpg";